import axios from "axios";

const apiUrl = `${process.env.REACT_APP_API_URL}/api/pages`;
const token = localStorage.getItem("token");

/// GET
// Fonction pour afficher toutes les pages personnalisées
export const getAllPages = async () => {
  try {
    const response = await axios.get(`${apiUrl}/getAllPages`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Erreur lors du chargement des pages personnalisées:", error);
    return [];
  }
};

// Fonction pour afficher tous les articles d'une page personnalisée
export const getAllArticlesByPage = async (pageId) => {
  try {
    const response = await axios.get(
      `${apiUrl}/getAllArticlesByPage/${pageId}`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      `Erreur lors du chargement des articles de la page ${pageId}:`,
      error
    );
    return [];
  }
};

// Fonction pour afficher une page par slug
export const getPageBySlug = async (slug) => {
  try {
    const response = await axios.get(`${apiUrl}/getPageBySlug/${slug}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Erreur lors du chargement de la page '${slug}':`, error);
    return null;
  }
};

/// POST
// Fonction pour créer une nouvelle page personnalisée
export const createPage = async (page) => {
  try {
    const response = await axios.post(`${apiUrl}/addPage`, page, {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la création de la page personnalisée:",
      error
    );
    return null;
  }
};

/// PUT
// Fonction pour modifier une page personnalisée
export const updatePage = async (page) => {
  try {
    const response = await axios.put(`${apiUrl}/updatePage/${page.id}`, page, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la modification de la page personnalisée:",
      error
    );
    return null;
  }
};

/// PATCH
// Fonction pour modifier la visibilité d'une page personnalisée
export const updatePageVisibility = async (pageId, actif) => {
  try {
    const response = await axios.patch(
      `${apiUrl}/updatePageVisibility/${pageId}`,
      { actif },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la mise à jour de la visibilité de la page:",
      error
    );
    return null;
  }
};

/// DELETE
// Fonction pour supprimer une page personnalisée
export const deletePage = async (pageId) => {
  try {
    const response = await axios.delete(`${apiUrl}/deletePage/${pageId}`, {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error(
      "Erreur lors de la suppression de la page personnalisée:",
      error
    );
    return null;
  }
};
